/* istanbul ignore file */
export const unstableFeaturesStatus = state => state.unstableFeaturesStatus;

export const unstableFeatureTester = unstableFeaturesStatus => featureName => {
  if (unstableFeaturesStatus.retrieved !== true) {
    throw new Error(
      `Unstable Features not yet retrieved, status for ${featureName} is not yet available`,
    );
  }
  const status = unstableFeaturesStatus.unstableFeatures[featureName];
  if (status !== false && status !== true) {
    throw new Error(
      `Unstable Feature Status for ${featureName} should either be true or false`,
    );
  }
  return status;
};



// WEBPACK FOOTER //
// ./src/sc/selectors/unstable-features.js